import { LedgerItem } from "@hubcapp/types";
import { Transaction as TableTransaction } from "@ds-developer/transactions-table";

export const mapGraphToTableTransactions = (
  ledgerItems: LedgerItem[],
): TableTransaction[] =>
  ledgerItems?.map(ledgerItem => ({
    id: ledgerItem.id,
    reference: ledgerItem.name,
    date: new Date(ledgerItem.date),
    value: ledgerItem.value,
    valueExVat: ledgerItem.valueExVat,
    isCancellable: false, // Hubcapp users shouldn't be able to delete their own ledger items
  })) || [];

export const filterFuture = (ledgerItem: LedgerItem): boolean =>
  new Date(ledgerItem.date) >= new Date(Date.now());

export const filterPast = (ledgerItem: LedgerItem): boolean =>
  new Date(ledgerItem.date) < new Date(Date.now());
